const ClipboardJS = require('clipboard');

const copyText = (options) => {

    const defaults = {
        copyBtn: '.js-copy-btn',
        copyValue: '.js-copy-value'
    };

    this.options = Object.assign(defaults, options);

    let clipboard = new ClipboardJS(this.options.copyBtn);

    clipboard.on('success', function(e) {
        $('.js-copy-copied').show();

        e.clearSelection();
    });

    // $(document).on('click', this.options.copyBtn, function () {
    //     $copyValue.focus();
    //     $copyValue.select();
    //
    //     try {
    //         let successful = document.execCommand('copy');
    //         let msg = successful ? 'successful' : 'unsuccessful';
    //         console.log('Copying text command was ' + msg);
    //     } catch (err) {
    //         console.log('Oops, unable to copy');
    //     }
    // });

};

export default copyText;
